const qyglGetter = {
    getEnterpriseEmployee(state) {
        return state.enterpriseEmployee;
    },
    getLearnAddEmployees(state) {
        return state.learnAddEmployees;
    },
    getLearnWeixinPayCode(state) {
        return state.learnWeixinPayCode;
    },
    getLearnWeixinPayResult(state) {
        return state.learnWeixinPayResult;
    },
    getLearnEnterpriselearn(state) {
        return state.enterpriseApprove;
    },
    getLearningmgtQY(state) {
        return state.learningmgtQY;
    },
    getMakeUpLearnDetails(state) {
        return state.makeUpLearnDetails;
    },
    getMakeUpEnterpriselearn(state) {
        return state.enterpriseMakeUpApprove;
    },
    getMyEnterprise(state) {
        return state.enterprise;
    },
    getCmType(state) {
        return state.cmType;
    },
    getCmJob(state) {
        return state.cmJob;
    },
    getAllCmJob(state) {
        return state.cmJob;
    },
    getCmCertificate(state) {
        return state.cmCertificate;
    },
    getCmCertificateDetails(state) {
        return state.cmCertificateDetails;
    },
    getRemoteCmCertificate(state) {
        return state.remoteCmCertificate;
    },
    getCmEmployee(state) {
        return state.cmEmployee;
    },
    getCmEmployeeDetails(state) {
        return state.cmEmployeeDetails;
    },
    getCmProject(state) {
        return state.cmProject;
    },
    getCmProjectDetails(state) {
        return state.cmProjectDetails;
    },
    getApproveLearns(state) {
        return state.approveLearns;
    },
    getQYInvoiceApproves(state) {
        return state.invoiceApproves;
    },
    getLastInvoiceApprove(state) {
        return state.lastInvoiceApprove;
    },
    getInvoiceApproveStates(state) {
        return state.invoiceApproveStates;
    },
    downloadInvoiceApproveContractTemplate(state) {
        return state.invoiceApproveContractTemplate;
    },
    downloadContractTemplate(state) {
        return state.contractTemplate;
    },

    getBdyTestBatchEmployees(state) {
        return state.bdyTestBatchEmployees;
    },
    getBdyTestBatchAddEmployees(state) {
        return state.bdyTestBatchAddEmployees;
    },
    getSelectBdyTestSessions(state) {
        return state.selectBdyTestSessions;
    },

    getExamBatchEmployees(state) {
        return state.examBatchEmployees;
    },
    getExamBatchAddEmployees(state) {
        return state.examBatchAddEmployees;
    },
    getSelectExamSessions(state) {
        return state.selectExamSessions;
    },

    getEnterpriseModifyApproves(state) {
        return state.enterpriseModifyApproves;
    },
    getEnterpriseModifyApproveStates(state) {
        return state.enterpriseModifyApproveStates;
    },

    getBdyPracticeEnrollAddEmployees(state) {
        return state.bdyPracticeEnrollAddEmployees;
    },

    getZjyTestBatchAddEmployees(state) {
        return state.zjyTestBatchAddEmployees;
    },

    getCertOldSources(state) {
        return state.certOldSources;
    },
    getCertOldSource(state) {
        return state.certOldSource;
    },
    getEnterpriseCertReplaces(state) {
        return state.enterpriseCertReplaces;
    },
    getCertReplaceDetails(state) {
        return state.certReplaceDetails;
    },
    getCertReplaceApproveStates(state) {
        return state.certReplaceApproveStates;
    },

    getSQEmployeeChangeApproves(state) {
        return state.sqEmployeeChangeApproves;
    },
    getSHEmployeeChangeApproves(state) {
        return state.shEmployeeChangeApproves;
    },
    getSHEmployeeChangeApproveCount(state) {
        return state.shEmployeeChangeApproveCount;
    },
    getEmployeeChangeApproveStates(state) {
        return state.employeeChangeApproveStates;
    },
    getSearchChangeEmployee(state) {
        return state.searchChangeEmployee;
    }
}

export default qyglGetter;



// WEBPACK FOOTER //
// ./src/store/jzjy/getters/qyglGetter.js